import {Box} from '@viptech/react-components'
import {useEffect, useState} from 'react'
import AppAddOrOptionsButton from 'src/components/AppAddOrOptionsButton'
import {useQueryParams} from 'src/hooks/useQuery'
import ClientsModal from 'src/pages/clients/components/ClientsModal'
import createStyleSheet from 'src/utilities/createStyleSheet'
import {useWindowSize} from 'usehooks-ts'
import {ValidateUserPermissions} from '../../common/utils/ValidatePermissions'
import {ConfirmationModal} from '../../components/ConfirmationModal/ConfirmationModal'
import AppReloadButton from '../../components/appReloadButton/AppReloadButton'
import {DropdownItem} from '../../components/dropdown/DropdownProps'
import {SelectWithSearchComponent} from '../../components/selectWithSearchComponent/SelectWithSearchComponent'
import TopBar from '../../components/top-bar/TopBar'
import {RenderIfConditionIsMet} from '../../utilities/RenderIfConditionIsMet'
import UserOptionsMenu from '../users/components/UserOptionsMenu'
import ClientsGridTable from './components/clients-grid-table/ClientsGridTable'
import ClientsContextProvider, {useClientsContext} from './contexts/ClientsContext'

function ClientsInner() {
  const {
    clientSearch,
    showOptionsButton,
    setClientSearch,
    reloadingClients,
    reloadClients,
    selectedClientsIds,
    deleteClient,
    setSearchFilterSelected,
    searchFilterData,
  } = useClientsContext()

  const hasCreateClientPermission = ValidateUserPermissions('clients:create')
  const [menuEl, setMenuEl] = useState<null | HTMLElement>(null)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [modalContent, setModalContent] = useState<string>('')
  const [modalTitle, setModalTitle] = useState<string>('')
  const menuOpen = Boolean(menuEl)
  const quantity = selectedClientsIds.length
  const isPlural: string = quantity === 1 ? '' : 's'
  const {width} = useWindowSize()
  const query = useQueryParams()

  function withConfirmation(message: string, title: string) {
    return () => {
      setMenuEl(null)
      setModalContent(title)
      setOpenModal(true)
      setModalTitle(message)
    }
  }
  const [showSearchSelected, setShowSearchSelected] = useState<DropdownItem>({
    id: '',
    label: '',
  })

  const onSelectChange = (e: DropdownItem) => {
    setShowSearchSelected(e)
    setSearchFilterSelected(e.label)
  }

  const [openCreateModal, setOpenCreateModal] = useState(false)

  useEffect(() => {
    if (query.has('new')) setOpenCreateModal(true)
  }, [])

  return (
    <Box style={styles.paper}>
      <TopBar>
        <Box display='flex' direction='row' justifyContent='space-between'>
          <Box display='flex' columnGap='16px' width={width >= 768 ? undefined : '99%'}>
            <AppReloadButton loading={reloadingClients} onClick={() => reloadClients()} />

            <SelectWithSearchComponent
              hideAdvancedFilters
              searchBy={searchFilterData}
              setSearchSelected={onSelectChange}
              searchSelected={showSearchSelected}
              inputValue={clientSearch}
              inputSearch={setClientSearch}
              widthOnSelect={'270px'}
            />
          </Box>

          <RenderIfConditionIsMet condition={hasCreateClientPermission && width >= 768}>
            <AppAddOrOptionsButton
              showOptions={showOptionsButton}
              onClickAdd={() => setOpenCreateModal(true)}
              onClickOptions={(e) => setMenuEl(e.currentTarget)}
              text='Adicionar um cliente'
            />
          </RenderIfConditionIsMet>
        </Box>
      </TopBar>
      <ClientsGridTable />

      <ClientsModal isOpen={openCreateModal} closeModal={() => setOpenCreateModal(false)} />

      <ConfirmationModal
        title={modalTitle}
        content={modalContent}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        buttonsContent={[
          {
            label: 'Cancelar',
            onClick: () => setOpenModal(false),
            variant: 'outlined',
            color: '#8E8E8E',
          },
          {
            label: 'Confirmar',
            onClick: () => {
              setOpenModal(false)
              setMenuEl(null)
              deleteClient()
            },
            variant: 'contained',
            color: '#009EFF',
          },
        ]}
      />
      <UserOptionsMenu
        open={menuOpen}
        anchorEl={menuEl}
        onClose={() => setMenuEl(null)}
        onDelete={withConfirmation(
          `Deletar cliente${isPlural}`,
          `Os registros deste${isPlural} cliente${isPlural} e todas as câmeras associadas serão removidas. Esta ação pode ser revertida.`,
        )}
      />
    </Box>
  )
}

function Clients() {
  return (
    <ClientsContextProvider>
      <ClientsInner />
    </ClientsContextProvider>
  )
}

const styles = createStyleSheet({
  paper: {
    borderRadius: '8px',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'white',
  },
})

export default Clients
